import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';
import { ISalesHistoryItem } from 'parts/types';

export const BillToAccountCell = ({ data, value }: ICellRendererParams<ISalesHistoryItem>) => {
  if (!data) {
    return value;
  }

  return (
    <Stack>
      <TextLine text={data.billToAccountName || DEFAULT_PLACEHOLDER} />
      <TextLine text={data.billToAccount || DEFAULT_PLACEHOLDER} isSubText />
    </Stack>
  );
};
